// Copyright (c) 2022 Deere & Company

import './base-machine.scss';
import React, {PropTypes} from 'react';
import BaseMachineComponentBody from './base-machine-component-body';
import FileAttachmentSinglePanel from '../../../claim/shared/components/file-attachment-single-panel';
import {FormattedMessage} from 'react-intl';
import Implements from '@deere/cps-it.warranty-model-factory/lib/implements';
import LabeledInput from '../../../claim/shared/components/claim-fields/labeled-input';

function handleInputChange(value) {

    this.onInputChange(value);

}

function handleDelete(index) {

    this.actions.deleteComponents(index);

}

function handleComponentChange(index, event) {

    this.actions.updateBaseMachineComponents(index, event.target.value);

}

function handleFileDelete(file) {

    this.actions.deleteFile(file);

}

function handleFileUpload(file, dropzone) {

    this.actions.addFile(JSON.parse(file.xhr.response));
    dropzone.removeFile(file);

}

const BaseMachineItem = props =>
    <section>
        <div className='base-machine-info'>
            <LabeledInput
                className='base-machine-pin'
                isEditable={false}
                label='BASE_MACHINE_PIN'
                value={props.baseMachineComponents.pin}
            />
            {props.baseMachinePurchaseOrder === '' ?
                <LabeledInput
                    className='purchase-order'
                    isEditable={true}
                    label='PURCHASE_ORDER'
                    onChange={handleInputChange.bind(props)}
                    value={props.baseMachineComponents.purchaseOrder}
                /> : <LabeledInput
                    className='purchase-order'
                    isEditable={false}
                    label='PURCHASE_ORDER'
                    value={props.baseMachineComponents.purchaseOrder}
                     />}
        </div>
        <div className='attachment'>
            <div className='uploadlabel'>
                <label>
                    <FormattedMessage id='UPLOAD_DOCUMENT'/>
                </label>
            </div>
            <FileAttachmentSinglePanel
                className='purchase-order'
                displayMessage='FILE_UPLOAD_MESSAGE_SINGLE'
                djsConfig={{maxFiles: 1}}
                file={props.baseMachineComponents.file}
                isRequired={false}
                isUploadAllowed={props.baseMachineComponents.file.fileName === '' && props.baseMachineComponents.file.fileSize === 0}
                onFileDelete={props::handleFileDelete}
                onFileUploadSuccess={props::handleFileUpload}
                serviceConfig={{
                    className: 'EQUI_PO',
                    classType: 'BO',
                    objectKey: props.baseMachineComponents.pin
                }}
            />
        </div>

        <div className={props.baseMachineComponents.components.length === 1 ? 'base-machine-component base-machine-single-component' : 'base-machine-component base-machine-multiple-component'}>
            <span
                className={'add-component'}
            >
                <FormattedMessage
                    id={'IMPLEMENTS'}
                />

            </span>
            {props.baseMachineComponents.components.map((component, index) =>
                component.isEditable ?
                    <BaseMachineComponentBody
                        component={component}
                        onComponentChange={handleComponentChange.bind(props, index)}
                        onDelete={handleDelete.bind(props, index)}

                    /> :
                        <span className='base-component-serialnumber'> {component.serialNumber}</span>

            )}

            <button
                className={props.isSubmitButtonDisabled ?
                       'add-component-icon-button add-component-button-without-component' :
                       'add-component-icon-button add-component-button-with-component'}
                onClick={props.actions.addComponents}
            />
        </div>
    </section>;

BaseMachineItem.displayName = 'BaseMachineItem';
BaseMachineItem.propTypes = {
    actions: PropTypes.object.isRequired,
    baseMachineComponents: PropTypes.instanceOf(Implements).isRequired,
    baseMachinePurchaseOrder: PropTypes.string.isRequired,
    isSubmitButtonDisabled: PropTypes.bool.isRequired,
    onInputChange: PropTypes.func.isRequired
};

export default BaseMachineItem;



// WEBPACK FOOTER //
// ./src/product/details/components/base-machine-item.js